import {
  getObjectFromStorage,
  removeFromStorage,
  setObjectToStorage,
} from "@/utils/localStorageUtils";

type Times = Record<string, number>;

/** Times in ms since the epoch by id, kept in localStorage under `key` and removed once empty. */
export const storedTimes = (key: string) => {
  const read = (): Times => getObjectFromStorage<Times>(key) ?? {};

  const write = (times: Times) => {
    if (Object.keys(times).length > 0) setObjectToStorage(key, times);
    else removeFromStorage(key);
  };

  /** Drops every id not in `live`, writing only when one was dropped. */
  const keepOnly = (live: Set<string>) => {
    const times = read();
    const kept = Object.entries(times).filter(([id]) => live.has(id));
    if (kept.length < Object.keys(times).length)
      write(Object.fromEntries(kept));
  };

  return { read, write, keepOnly };
};
